import { useId, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { FiFlag } from "react-icons/fi";
import useTranslator from "../../hooks/useTranslator";
import CreateSkorTicketModal from "./CreateSkorTicketModal";
import styles from "./SkorTicket.module.css";

export default function SkorTicketButton({
  tenant,
  isGuarantor = false,
  hasMissingDocuments = false,
  onMissingDocumentsClick,
}) {
  const { _t } = useTranslator();
  const [isOpen, setIsOpen] = useState(false);
  const userType = localStorage.getItem("usertype");
  const buttonId = useId();
  const [menuAnchor, setMenuAnchor] = useState(null);
  const showReportMenu =
    userType === "tenant" &&
    !isGuarantor &&
    hasMissingDocuments &&
    typeof onMissingDocumentsClick === "function";
  if (!["tenant", "landlord"].includes(userType)) return null;

  return (
    <div className={styles.buttonWrap}>
      <button
        id={buttonId}
        type="button"
        className={styles.reportButton}
        aria-haspopup={showReportMenu ? "menu" : undefined}
        aria-expanded={showReportMenu ? Boolean(menuAnchor) : undefined}
        onClick={(event) => {
          if (showReportMenu) setMenuAnchor(event.currentTarget);
          else setIsOpen(true);
        }}
      >
        <FiFlag aria-hidden="true" />
        {_t("skorTicketReportProblem", "Report a problem")}
      </button>
      <Menu
        anchorEl={menuAnchor}
        open={showReportMenu && Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        MenuListProps={{ "aria-labelledby": buttonId }}
        PaperProps={{ className: styles.reportMenu }}
      >
        <MenuItem
          onClick={() => {
            setMenuAnchor(null);
            onMissingDocumentsClick();
          }}
        >
          {_t("skorTicketWrongDocument", "Wrong with the document")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setMenuAnchor(null);
            setIsOpen(true);
          }}
        >
          {_t("skorTicketOther", "Other")}
        </MenuItem>
      </Menu>
      {isOpen && (
        <CreateSkorTicketModal
          tenant={tenant}
          isGuarantor={isGuarantor}
          onClose={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}
